/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_rS as rS,
} from "../../runtime/index.jsx";
export function Componente_ID_73_68(e) {
  return (
    <span
      key={e.id}
      className={`rounded-full px-1.5 py-0.5 text-[10px]`}
      style={rS(e)}
      children={e.nombre}
    />
  );
}
